import cookie from 'react-cookies'

const COOKIE_KEY = 'ccpa'
export default class CcpaCookieHelper {
  static getCookie() {
    let ccpaCookie = cookie.load(COOKIE_KEY)
    if (!ccpaCookie) {
      return null
    }

    return ccpaCookie
  }

  static setCookie(ccpaValue) {
    const expires = new Date()
    expires.setDate(expires.getDate() + 365)
    const ccpa = { value: ccpaValue, timestamp: new Date() }
    cookie.save(COOKIE_KEY, ccpa, { path: '/', secure: false, httpOnly: false, expires: expires })
    return ccpa
  }

  static overwriteCookieValue({ ccpaVal, ccpaUpdatedAt }) {
    const expires = new Date()
    expires.setDate(expires.getDate() + 365)
    const ccpa = { value: ccpaVal, timestamp: ccpaUpdatedAt }
    cookie.save(COOKIE_KEY, ccpa, { path: '/', secure: false, httpOnly: false, expires: expires })
    return ccpa
  }

  static isCookieSet() {
    return !!cookie.load(COOKIE_KEY)
  }
}



// WEBPACK FOOTER //
// ./assets/js/lib/Ccpa/CcpaCookieHelper.jsx